"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotFaceHappy = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotFaceHappy = _ref => {
  let {
    spotColor = "#1AD3B2",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "face_teal_happy_svg__a",
    d: "M0 0h37v37H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "face_teal_happy_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#face_teal_happy_svg__a"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M1 18.5C1 28.15 8.85 36 18.5 36S36 28.15 36 18.5 28.15 1 18.5 1 1 8.85 1 18.5Z",
    mask: "url(#face_teal_happy_svg__b)",
    opacity: 0.5
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M18.5 0C28.7 0 37 8.3 37 18.5S28.701 37 18.5 37 0 28.7 0 18.5 8.299 0 18.5 0Zm0 1.516C9.135 1.516 1.516 9.135 1.516 18.5c0 9.365 7.619 16.984 16.984 16.984 9.365 0 16.984-7.619 16.984-16.984 0-9.365-7.619-16.984-16.984-16.984ZM12.682 11.98c1.195 0 2.122.463 2.661 1.383a.828.828 0 0 1-1.365.93l-.063-.094c-.222-.378-.593-.564-1.233-.564-.582 0-.942.153-1.17.466l-.064.098a.828.828 0 1 1-1.428-.836c.539-.92 1.466-1.383 2.662-1.383Zm12.658 0c1.195 0 2.122.463 2.661 1.383a.828.828 0 0 1-1.365.93l-.063-.094c-.222-.378-.593-.564-1.233-.564-.582 0-.942.153-1.17.466l-.064.098a.828.828 0 1 1-1.428-.836c.539-.92 1.466-1.383 2.662-1.383Z",
    mask: "url(#face_teal_happy_svg__b)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "nonzero",
    d: "M28 21.25H10.214a.96.96 0 0 0-.96.978c.164 4.237 4.508 7.522 9.746 7.522 5.35 0 9.75-3.423 9.75-7.75a.75.75 0 0 0-.75-.75Zm-.811 1.5-.008.055C26.66 25.842 23.224 28.25 19 28.25l-.28-.004c-4.089-.103-7.394-2.469-7.902-5.444l-.009-.052h16.38Z",
    mask: "url(#face_teal_happy_svg__b)"
  })));
};
exports.SpotFaceHappy = SpotFaceHappy;
SpotFaceHappy.displayName = "SpotFaceHappy";